<template>
  <vx-card :title="'Grafik '+item.title" subtitle="Data disajikan dalam periode tahun" class="mb-base">
    <!-- Chart -->
    <template slot="no-body">
      <div class="my-10">
        <Bar :chart-options="chartOptions"
          :chart-data="chartData"
          :chart-id="item.type+'-chart'"
          :width="width"
          :height="height"
        />
      </div>
    </template>

    <!-- Details -->
    <div class="flex flex-col md:flex-row justify-between text-center" slot="no-body-bottom"></div>
  </vx-card>
</template>

<script>
import { Bar } from 'vue-chartjs/legacy';
import { formatRupiah } from '@/utils/filter.js';

export default {
  components: { Bar , formatRupiah},
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed:{
    chartOptions(){
      return this.setChartOptions();
    }
  },
  data() {
    return {
      loading: true,
      width: 380,
      height: 137,
      chartData: {
        datasets: [],
        labels: []
      },
      defaultColor: '#FFFFFF'
    }
  },
  mounted() {
    this.loadSeries()
  },
  methods: {
    async loadSeries() {
      this.loading = true;
      const res = await this.$http.get('/realization/graph-data', {
        params: {
          type: this.item.type
        }
      })
      this.setChartData(res.data.data);
      this.loading = false;
    },
    setChartData(chartData){
      this.chartData.labels = chartData.labels
      this.chartData.datasets[0] = {
        label: this.item.target.title,
        data: chartData.target,
        backgroundColor: this.setItemColors(this.item.target.color),
        borderColor: this.setItemColors(this.defaultColor),
        borderWidth: 2,
        barThickness: this.item.barThickness
      }
      this.chartData.datasets[1] = {
        label: this.item.realization.title,
        data: chartData.realization,
        backgroundColor: this.setItemColors(this.item.realization.color),
        borderColor: this.setItemColors(this.defaultColor),
        borderWidth: 1,
        barThickness: this.item.barThickness
      }
    },
    setItemColors(color){
      let colors = [];
      for(let i = 1; i < 20; i++){
        colors.push(color);
      }
      return colors;
    },
    setChartOptions(){
      return {
        responsive: true,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              userCallback: function(value) {
                return formatRupiah(value);
              }
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label;
              var val = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              return ` ${label}: ${formatRupiah(val)}`;
            }
          }
        }
      }
    }
  }
}
</script>